/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-plusplus */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react/sort-comp */
import React from 'react';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import { ToastsStore } from 'react-toasts';
import { submitAbsenceForm } from '../../apis/Network';
import history from '../../utils/history';
import LoadingIndicator from '../../View/LoadingIndicator';
import { errMsg } from '../../utils/messages';
import { reasons } from '../../utils/formData';
// import api from '../../utils/api';
// import { GET_PARENT_CONTACT } from '../../utils/apiEndPoint';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // periods: [],
      reason: '',
      // relationship: '',
      // first_name: '',
      // last_name: '',
      errors: {},
      // other: '',
      loading: false,
      showErrorMsgAtSubmit: false,
      // contactDetails: [],
      // errorGetData: false,
      // getDataLoading: true,
      // parentConatctId: null,
      submitErrorMsg: '',
    };
    // this.onChangePeriods = this.onChangePeriods.bind(this);
    this.onChangereason = this.onChangereason.bind(this);
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.checkAll = this.checkAll.bind(this);
    this.onParentNameChange = this.onParentNameChange.bind(this);
  }

  componentDidMount() {
    // this.getParentDetail();
  }

  // getParentDetail() {
  //   setTimeout(() => {
  //     const loggedInUser = JSON.parse(sessionStorage.getItem('login_details'));
  //     api.get(`${GET_PARENT_CONTACT}/${loggedInUser.studentid}`)
  //       .then((res) => {
  //         if (res.status === 200) {
  //           this.setState({ contactDetails: res.data });
  //         } else {
  //           this.setState({ errorGetData: true });
  //         }
  //         this.setState({ getDataLoading: false });
  //       })
  //       .catch(() => {
  //         this.setState({ errorGetData: true });
  //         this.setState({ getDataLoading: false });
  //       });
  //   }, 2000);
  // }

  /* onChangePeriods(e) {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const { periods } = this.state;
    const options = periods;
    let index;
    const select_all = document.querySelector('#select_all');
    select_all.checked = false;
    document.getElementById('s_all').innerHTML = 'select All';
    // check if the check box is checked or unchecked
    if (e.target.checked) {
      // add the numerical value of the checkbox to options array
      options.push(+e.target.value);
    } else {
      // or remove the value from the unchecked checkbox from the array
      index = options.indexOf(+e.target.value);
      options.splice(index, 1);
    }

    // update the state with the new array of options
    this.setState({ periods: options });
  } */

  onChangereason(e) {
    this.setState({
      reason: e.target.value,
      submitErrorMsg: '',
    });
    const { errors } = this.state;
    errors.reason = '';
  }

  handleValidation() {
    const fields = this.state;
    const errors = {};
    let formIsValid = true;

    if (!fields.reason) {
      formIsValid = false;
      errors.reason = 'Must select atleast one';
    }
    // if (!fields.parentConatctId) {
    //   formIsValid = false;
    //   errors.parentConatctId = 'Please select your relationship with student.';
    // }
    /* if (!fields.first_name) {
      formIsValid = false;
      errors.first_name = 'Cannot be empty';
    }
    if (!fields.last_name) {
      formIsValid = false;
      errors.last_name = 'Cannot be empty';
    }
    if (!fields.relationship) {
      formIsValid = false;
      errors.relationship = 'Must select atleast one';
    }
    if (fields.relationship === 'Other') {
      if (!fields.other) {
        formIsValid = false;
        errors.other = 'Cannot be empty';
      }
    } */

    this.setState({ errors });
    return formIsValid;
  }

  onParentNameChange(event) {
    if (event.target.value) {
      const { errors } = this.state;
      errors.parentConatctId = '';
    }
    this.setState({
      // parentConatctId: event.target.value,
      submitErrorMsg: '',
    });
  }

  handleSubmitForm(event) {
    event.preventDefault();
    if (this.handleValidation()) {
      const { absenceData } = this.props;
      const data = this.state;
      const loggedInUser = JSON.parse(sessionStorage.getItem('login_details'));

      const token = sessionStorage.getItem('token');
      let allPeriods = '';
      for (let i = 0; i < absenceData.length; i++) {
        if (i === 0) {
          allPeriods += absenceData[i].period;
        } else {
          allPeriods += `,${absenceData[i].period}`;
        }
      }
      /* const parentDetail = data.contactDetails.filter((contact) => (
        contact.contact_id === data.parentConatctId
      )); */
      const response = {
        token,
        student_id: loggedInUser.studentId,
        periods: allPeriods,
        absence_date: absenceData[0].absence_date,
        reason: data.reason,
        // contact_id: data.parentConatctId,
        // parent_name: parentDetail[0].contact_name,
        // relationship: parentDetail[0].relation_description,
      };

      this.setState({
        loading: true,
      });

      submitAbsenceForm(loggedInUser, response)
        .then(
          (response1) => {
            console.log(response1);
            if (response1.status === 200) {
              this.setState({
                loading: false,
                submitErrorMsg: '',
              });
              ToastsStore.success(response1.msg);
              history.push('/absenceform');
            } else {
              this.setState({
                loading: false,
                showErrorMsgAtSubmit: true,
                submitErrorMsg: response1.msg,
              });
              console.log(response1.msg);
            }
          },
          (error) => {
            console.log('bp12-submitEarlyForm', error);
            this.setState({
              loading: false,
              showErrorMsgAtSubmit: true,
              submitErrorMsg: errMsg,
            });
          },
        )
        .catch((error) => {
          console.log(error);
          this.setState({
            loading: false,
            showErrorMsgAtSubmit: true,
            submitErrorMsg: errMsg,
          });
        });
    } else {
      // console.log("Form has errors.")
    }
  }

  checkAll(ele) {
    const checkboxes = document.getElementsByTagName('input');
    if (ele.target.checked) {
      for (let i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].type === 'checkbox' && !checkboxes[i].disabled) {
          checkboxes[i].checked = true;
          document.getElementById('s_all').innerHTML = 'Unselect All';
        }
      }
    } else {
      for (let j = 0; j < checkboxes.length; j++) {
        if (checkboxes[j].type === 'checkbox') {
          checkboxes[j].checked = false;
          document.getElementById('s_all').innerHTML = 'select All';
        }
      }
    }
  }

  render() {
    const { absenceData } = this.props;
    console.log(absenceData);
    const {
      errors, loading, showErrorMsgAtSubmit, getDataLoading, submitErrorMsg,
    } = this.state;

    return (
      <form method="post" className="earlyform">
        <div style={{ cursor: 'not-allowed' }}>
          <DatePickerInput
            id="req_absence_date"
            value={new Date(absenceData[0].absence_date)}
            className="my-custom-datepicker-component"
            required
            placeholder="mm/dd/yyyy"
            returnFormat="YYYY/MM/DD"
            showOnInputClick
            disabled
          />
          <span style={{ color: 'red', fontSize: 12 }}>{errors.absence_date}</span>
        </div>
        <div className={getDataLoading ? 'column loader-side' : 'column'}>
          <h3>
            Periods
            {' '}
            <span className="required" style={{ color: 'red', fontSize: 12 }}>*</span>
          </h3>
          <h6>Absence periods.</h6>
          <ul>
            {
              // eslint-disable-next-line arrow-body-style
              absenceData.map((val) => (
                <li key={val.id}>
                  <input
                    type="checkbox"
                    id={val.id}
                    className="period_checkbox disabled"
                    name="period[]"
                    value={val.period}
                    checked
                    disabled
                  />

                  <label htmlFor={val.id}>
                    {`Period ${val.period}`}
                    {' '}
                    <span>{`P${val.period}`}</span>
                  </label>
                </li>
              ))
            }
            {/* <li className="li-disabled">
              <input type="checkbox" id="select_all" onChange={this.checkAll}
              className="period_checkbox select_all" name="select_all" value="" disabled />
              <label htmlFor="select_all">
                Select All
                <span id="s_all">Select All</span>
              </label>
          </li> */}
          </ul>
          {/* <div>
            {!getDataLoading && (
            <>
              {errorGetData ? <p>Something went wrong, Unable to get parent details</p> : (
                <>
                  <h3>
                    Parent Name and Relationship
                    {' '}
                    <span className="required" style={{ color: 'red', fontSize: 12 }}>*</span>
                  </h3>
                  <select
                    className="parent-name-relate"
                    id="parentName"
                    onChange={this.onParentNameChange}
                  >
                    <option selected value="">
                      Select...
                    </option>
                    {contactDetails.map((contact) => (
                      <option value={contact.contact_id}>
                        {`${contact.contact_name} (${contact.relation_description})`}
                      </option>
                    ))}
                  </select>
                </>
              )}
            </>
            )}
            {errors.parentConatctId
            && <span style={{ color: 'red', fontSize: 12 }}>{errors.parentConatctId}</span>}
          </div> */}
        </div>
        {/* { !getDataLoading && ( */}
        <div className="column reasons_position">
          <h3>
            Reason
            {' '}
            <span className="required" style={{ color: 'red', fontSize: 12 }}>*</span>
          </h3>
          <h6>You are only allowed to choose one reason.</h6>
          <ul>
            {
              reasons.map((res) => (
                <li key={res.value}>
                  <input type="radio" id={res.label} name="reason" value={res.value} onChange={this.onChangereason} required />
                  <label htmlFor={res.label}>{res.label}</label>
                </li>
              ))
            }
          </ul>
          <span style={{ color: 'red', fontSize: 12 }}>{errors.reason}</span>
        </div>
        {/* )} */}
        {/* {!getDataLoading && (
        <button
          id="submit_btn"
          className="clear_absence"
          type="submit"
          onClick={this.handleSubmitForm}
        >
          {loading ? <LoadingIndicator className="login-loader" /> : 'Submit'}
        </button>
        )} */}
        <button
          id="submit_btn"
          className="clear_absence"
          type="submit"
          onClick={this.handleSubmitForm}
        >
          {loading ? <LoadingIndicator className="login-loader" /> : 'Submit'}
        </button>
        {/* {getDataLoading && (<LoadingIndicator className="login-loader" />)} */}
        {showErrorMsgAtSubmit ? <p className="showErrorMsgAtSubmit" style={{ fontSize: 12 }}>{submitErrorMsg}</p> : null}
      </form>

    );
  }
}

/*
<div className="column column_full">
          <div className="left_input">
            <h3>
              Parent Name
              {' '}
              <span className="required" style={{ color: 'red', fontSize: 12 }}>*</span>
            </h3>
            <div className="mac-input-box">
              <h5>First Name</h5>
              <input
                id="first_name"
                maxLength="50"
                className="ecr-input"
                name="first_name"
                onChange={(e) => {
                  if (!/[^a-zA-Z]/.test(e.target.value)) {
                    this.setState({ first_name: e.target.value });
                    errors.first_name = '';
                  }
                }}
                value={first_name}
              />
              <span style={{ color: 'red', fontSize: 12 }}>{errors.first_name}</span>
            </div>
            <div className="mac-input-box">
              <h5>Last Name</h5>
              <input
                id="last_name"
                maxLength="50"
                className="ecr-input"
                name="last_name"
                onChange={(e) => {
                  if (!/[^a-zA-Z]/.test(e.target.value)) {
                    this.setState({ last_name: e.target.value });
                    errors.last_name = '';
                  }
                }}
                value={last_name}
              />
              <span style={{ color: 'red', fontSize: 12 }}>{errors.last_name}</span>
            </div>
          </div>
          <div className="right_input">
            <h3>
              Relationship
              {' '}
              <span className="required" style={{ color: 'red', fontSize: 12 }}>*</span>
            </h3>
            <ul>
              {
                relationship.map((res) => (
                  <li key={res.value}>
                    <input
                      type="radio"
                      id={res.label}
                      name="relationship"
                      value={res.value}
                      onChange={
                        (e) => {
                          this.setState({ relationship: e.target.value });
                          errors.other = '';
                          errors.relationship = '';
                        }
                      }
                    />
                    <label htmlFor={res.label}>{res.label}</label>
                  </li>
                ))
              }
            </ul>
            <span style={{ color: 'red', fontSize: 12 }}>{errors.relationship}</span>
            {
              relationship === 'Other'
                ? (
                  <input
                    id="other"
                    className="ecr-input"
                    name="other"
                    maxLength="50"
                    onChange={(e) => {
                      if (!/[^a-zA-Z]/.test(e.target.value)) {
                        this.setState({ other: e.target.value });
                        errors.other = '';
                      }
                    }}
                    value={other}
                    hidden={false}
                    required
                  />
                )
                : (
                  <input
                    id="other"
                    className="ecr-input"
                    name="other"
                    maxLength="50"
                    onChange={(e) => {
                      if (!/[^a-zA-Z]/.test(e.target.value)) {
                        this.setState({ other: e.target.value });
                        errors.other = '';
                      }
                    }}
                    value={other}
                    hidden
                  />
                )
              }
            <span style={{ color: 'red', fontSize: 12 }}>{errors.other}</span>
          </div>
        </div>
*/
